import React from 'react';
import PropTypes from 'prop-types';

const UserTitle = ({ record }) => <span>{record.full_name}</span>;

UserTitle.propTypes = {
  record: PropTypes.object,
};

UserTitle.defaultProps = {
  record: null,
};

export default UserTitle;



// WEBPACK FOOTER //
// ./src/resources/users/show/UserTitle.jsx